<template>
	<div class="desktop-config step-5-specs">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-6 col-xs-12">
					<div class="part-item part-item-1">
						<div class="row" v-if="activeBuild.case">
							<div class="col-md-8 col-xs-8 text-left">
								<div class="part-name">CASE:</div>
								<div class="part-label">
									<p :class="{ unavailable: checkDisabled(activeBuild.case) }">
										{{ activeBuild.case.title }}
										{{ !(+activeBuild.case.is_limited) ? '(' + activeBuild.case.colors + ')' : '' }}
									</p>
								</div>
							</div>
							<div class="col-md-4 col-xs-4 part-price text-right">
								<promo-sales-timed>
									<template v-slot:originalContent>
										<div class="msrp">MSRP</div>
										<p>${{ activeBuild.case.price | priceFormat }}</p>
									</template>
									<template>
										<div class="checkout-price__amount-container">
											<template v-if="applyCase">
												<div class="msrp">MSRP</div>
												<p>Gifted</p>
											</template>
											<template v-else>
												<div class="msrp">MSRP</div>
												<div class="holiday-promo">
													<p>${{ discountPrice | priceFormat }}</p>
													<p class="holiday-discount">${{ activeBuild.case.price | priceFormat }}</p>
												</div>
											</template>
										</div>
									</template>
								</promo-sales-timed>
							</div>
						</div>
						<p v-if="checkDisabled(activeBuild.case)" class="part-warning" @click="fixCase()">
							<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
							No longer available, choose another.
						</p>
					</div>
					<div class="part-item part-item-2">
						<div class="row" v-if="activeBuild.gpu">
							<div class="col-md-8 col-xs-8 text-left">
								<div class="part-name">GPU:</div>
								<div class="part-label">
									<p :class="{ unavailable: checkDisabled(activeBuild.gpu) }">
										{{ activeBuild.gpu.title }}
										<template v-if="activeBuild.gpu.quantity > 1">
											({{ activeBuild.gpu.quantity }})
										</template>
									</p>
								</div>
							</div>
							<div class="col-md-4 col-xs-4 part-price text-right">
								<div class="msrp">MSRP</div>
								<p>
									${{ activeBuild.gpu.price * activeBuild.gpu.quantity | priceFormat }}
								</p>
							</div>
						</div>
						<p v-if="checkDisabled(activeBuild.gpu)" class="part-warning" @click="$emit('fix-this', 'gpu', 'gpu-options')">
							<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
							No longer available, choose another.
						</p>
					</div>
					<div class="part-item part-item-3">
						<div class="row" v-if="activeBuild.cpu">
							<div class="col-md-8 col-xs-8 text-left">
								<div class="part-name">CPU:</div>
								<div class="part-label">
									<p :class="{ unavailable: checkDisabled(activeBuild.cpu) }">
										{{ activeBuild.cpu.title }}
									</p>
								</div>
							</div>
							<div class="col-md-4 col-xs-4 part-price text-right">
								<div class="msrp">MSRP</div>
								<p>${{ activeBuild.cpu.price | priceFormat }}</p>
							</div>
						</div>
						<p v-if="checkDisabled(activeBuild.cpu)" class="part-warning" @click="$emit('fix-this', 'cpu', 'cpu-options')">
							<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
							No longer available, choose another.
						</p>
					</div>
					<div class="part-item part-item-cpu-cooling">
						<div class="row" v-if="activeBuild.cpuCooler">
							<div class="col-md-8 col-xs-8 text-left">
								<div class="part-name">CPU COOLING:</div>
								<div class="part-label">
									<p :class="{ unavailable: checkDisabled(activeBuild.cpuCooler) }">
										{{ activeBuild.cpuCooler.title }}
									</p>
								</div>
							</div>
							<div class="col-md-4 col-xs-4 part-price text-right">
								<div class="msrp">MSRP</div>
								<p v-if="+activeBuild.cpuCooler.price">
									${{ activeBuild.cpuCooler.price | priceFormat }}
								</p>
								<p v-else>
									&mdash;
								</p>
							</div>
						</div>
						<p v-if="checkDisabled(activeBuild.cpuCooler)" class="part-warning" @click="$emit('fix-this', 'cooling', 'cooling-options')">
							<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
							No longer available, choose another.
						</p>
					</div>
					<div class="part-item part-item-5">
						<div class="row" v-if="activeBuild.motherboard">
							<div class="col-md-8 col-xs-8 text-left">
								<div class="part-name">MOTHERBOARD:</div>
								<div class="part-label">
									<p :class="{ unavailable: checkDisabled(activeBuild.motherboard) }">
										{{ activeBuild.motherboard.title }}
										{{ motherboardColorsList.length > 1 ? '(' + activeBuild.motherboard.colors + ')' : '' }}
									</p>
								</div>
							</div>
							<div class="col-md-4 col-xs-4 part-price text-right">
								<div class="msrp">MSRP</div>
								<p>${{ activeBuild.motherboard.price | priceFormat }}</p>
							</div>
						</div>
						<p v-if="checkDisabled(activeBuild.motherboard)" class="part-warning" @click="fixMotherboard()">
							<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
							No longer available, choose another.
						</p>
					</div>
					<div class="part-item part-item-6">
						<div class="row" v-if="activeBuild.ram">
							<div class="col-md-8 col-xs-8 text-left">
								<div class="part-name">RAM:</div>
								<div class="part-label">
									<p :class="{ unavailable: checkDisabled(activeBuild.ram) }">
										{{ activeBuild.ram.product_name }}
										<small>(max speed)</small>
										<span v-html="computeRamCapacity(activeBuild.ram.capacity, activeBuild.ram.slots, activeBuild.ram.quantity)" />
									</p>
								</div>
							</div>
							<div class="col-md-4 col-xs-4 part-price text-right">
								<div class="msrp">MSRP</div>
								<p>${{ activeBuild.ram.price * activeBuild.ram.quantity | priceFormat }}</p>
							</div>
						</div>
						<p v-if="checkDisabled(activeBuild.ram)" class="part-warning" @click="$emit('fix-this', 'ram', 'ram-options')">
							<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
							No longer available, choose another.
						</p>
					</div>
					<div class="part-item part-item-7" v-if="activeBuild.ssd && activeBuild.ssd.length && (activeBuild.ssd[0].id || activeBuild.ssd.length > 1)">
						<div class="row">
							<div class="col-xs-12">
								<div class="part-name pull-left">SSD:</div>
								<div class="msrp pull-right">MSRP</div>
							</div>
						</div>
						<template v-for="(disk, index) in activeBuild.ssd">
							<div class="row" :key="`overlay-ssd-${index}-${disk.products_id}`">
								<div class="col-md-8 col-xs-8 text-left">
									<div class="part-label">
										<p :class="{ unavailable: checkDisabled(disk) }" v-if="disk.id">
											{{ disk.title }}
											{{ disk.capacity }}
											<template v-if="disk.quantity > 1">
												({{ disk.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div class="col-md-4 col-xs-4 part-price text-right">
									<template v-if="disk.id">
										<p>${{ disk.price * disk.quantity | priceFormat }}</p>
									</template>
								</div>
							</div>
							<p
								v-if="checkDisabled(disk)"
								:key="`overlay-ssd-${index}-${disk.products_id}-warn`"
								class="part-warning"
								@click="fixStorage(disk)"
							>
								<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
								<template v-if="totalStorage > 1">
									No longer available. Remove.
								</template>
								<template v-else>
									No longer available, choose another.
								</template>
							</p>
						</template>
					</div>
					<div class="part-item part-item-8" v-if="activeBuild.hdd && activeBuild.hdd.length && (activeBuild.hdd[0].id || activeBuild.hdd.length > 1)">
						<div class="row">
							<div class="col-xs-12">
								<div class="part-name pull-left">HDD:</div>
								<div class="msrp pull-right">MSRP</div>
							</div>
						</div>
						<template v-for="(disk, index) in activeBuild.hdd">
							<div class="row" :key="`overlay-hdd-${index}-${disk.products_id}`">
								<div class="col-md-8 col-xs-8 text-left">
									<div class="part-label">
										<p :class="{ unavailable: checkDisabled(disk) }" v-if="disk.id">
											{{ disk.title }}
											{{ disk.capacity }}
											<template v-if="disk.quantity > 1">
												({{ disk.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div class="col-md-4 col-xs-4 part-price text-right">
									<template v-if="disk.id">
										<p>${{ disk.price * disk.quantity | priceFormat }}</p>
									</template>
								</div>
							</div>
							<p
								v-if="checkDisabled(disk)"
								:key="`overlay-hdd-${index}-${disk.products_id}-warn`"
								class="part-warning"
								@click="fixStorage(disk)"
							>
								<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
								<template v-if="totalStorage > 1">
									No longer available. Remove.
								</template>
								<template v-else>
									No longer available, choose another.
								</template>
							</p>
						</template>
					</div>
					<div class="part-item part-item-9">
						<div class="row">
							<div class="col-md-8 col-xs-8 text-left">
								<div class="part-name">POWER:</div>
								<div class="part-label">
									<p :class="{ unavailable: checkDisabled(activeBuild.powerSupply) }">
										{{ activeBuild.powerSupply.title }}
									</p>
								</div>
							</div>
							<div class="col-md-4 col-xs-4 part-price text-right">
								<div class="msrp">MSRP</div>
								<p v-if="+activeBuild.powerSupply.price">
									${{ activeBuild.powerSupply.price | priceFormat }}
								</p>
								<p v-else>
									&mdash;
								</p>
							</div>
						</div>
						<p v-if="checkDisabled(activeBuild.powerSupply)" class="part-warning" @click="$emit('fix-this', 'psu', 'psu-options')">
							<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
							No longer available, choose another.
						</p>
					</div>
				</div>
				<div class="col-md-6 col-xs-12">
					<div>
						<div class="part-item part-item-fans" v-if="activeBuild.caseFans && activeBuild.caseFans.length && (activeBuild.caseFans[0].id || activeBuild.caseFans.length > 1)">
							<div class="row">
								<div class="col-xs-12">
									<div class="part-name pull-left">FANS:</div>
									<div class="msrp pull-right">MSRP</div>
								</div>
							</div>
							<template v-for="(fan, index) in activeBuild.caseFans">
								<div :key="`overlay-fan-${index}`" class="row">
									<div class="col-md-8 col-xs-8 text-left">
										<div class="part-label">
											<p :class="{ unavailable: checkDisabled(fan) }" v-if="fan.id">
												{{ fan.title }}
												({{ fan.colors }})
												<template v-if="fan.quantity > 1">
													({{ fan.quantity }})
												</template>
											</p>
										</div>
									</div>
									<div class="col-md-4 col-xs-4 part-price text-right">
										<p class="0" v-if="fan.id">
											${{ fan.price * fan.quantity | priceFormat }}
										</p>
									</div>
								</div>
								<p
									v-if="checkDisabled(fan)"
									:key="`overlay-fan-${index}-warn`"
									class="part-warning"
									@click="fixFan(fan)"
								>
									<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
									<template v-if="+fan.disabled_product">
										No longer available. Remove.
									</template>
									<template v-else>
										No longer available, choose another.
									</template>
								</p>
							</template>
						</div>
						<div class="part-item part-item-rgb" v-if="activeBuild.rgbs && activeBuild.rgbs.length && (activeBuild.rgbs[0].id || activeBuild.rgbs.length > 1)">
							<div class="row">
								<div class="col-xs-12">
									<div class="part-name pull-left">RGBs:</div>
									<div class="msrp pull-right">MSRP</div>
								</div>
							</div>
							<template v-for="(rgb, index) in activeBuild.rgbs">
								<div class="row" :key="`overlay-rgbs-${index}`">
									<div class="col-md-8 col-xs-8 text-left">
										<div class="part-label">
											<p :class="{ unavailable: checkDisabled(rgb) }" v-if="rgb.id">
												{{ rgb.title }} {{ rgb.colors ? '(' + rgb.colors + ')' : '' }}
											</p>
										</div>
									</div>
									<div class="col-md-4 col-xs-4 part-price text-right">
										<template v-if="rgb.id">
											<p>${{ rgb.price | priceFormat }}</p>
										</template>
									</div>
								</div>
								<p
									v-if="checkDisabled(rgb)"
									:key="`overlay-rgbs-${index}-warn`"
									class="part-warning"
									@click="fixPart(rgb)"
								>
									<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
									No longer available. Remove.
								</p>
							</template>
						</div>
						<div class="part-item part-item-extra" v-if="activeBuild.extras && activeBuild.extras.length && (activeBuild.extras[0].id || activeBuild.extras.length > 1)">
							<div class="row">
								<div class="col-xs-12">
									<div class="part-name pull-left">ACCESSORIES:</div>
									<div class="msrp pull-right">MSRP</div>
								</div>
							</div>
							<template v-for="(extra, index) in activeBuild.extras">
								<div class="row" :key="`overlay-accessory-${index}`">
									<div class="col-md-8 col-xs-8 text-left">
										<div class="part-label">
											<p :class="{ unavailable: checkDisabled(extra) }" v-if="extra.id">
												{{ extra.title }} {{ extra.colors ? '(' + extra.colors + ')' : '' }}
											</p>
										</div>
									</div>
									<div class="col-md-4 col-xs-4 part-price text-right">
										<p>${{ extra.price | priceFormat }}</p>
									</div>
								</div>
								<p
									v-if="checkDisabled(extra)"
									:key="`overlay-accessory-${index}-warn`"
									class="part-warning"
									@click="fixPart(extra)"
								>
									<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
									No longer available. Remove.
								</p>
							</template>
						</div>
						<div class="part-item part-item-streaming-bundle" v-if="activeBuild.streamingBundle && activeBuild.streamingBundle.id">
							<div class="row">
								<div class="col-xs-12">
									<div class="part-name pull-left">STREAMING:</div>
									<div class="msrp pull-right">MSRP</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-8 col-xs-8 text-left">
									<div class="part-label">
										<p :class="{ unavailable: checkDisabled(activeBuild.streamingBundle) }" v-if="activeBuild.streamingBundle.id">
											{{ activeBuild.streamingBundle.title }} {{ activeBuild.streamingBundle.colors ? '(' + activeBuild.streamingBundle.colors + ')' : '' }}
										</p>
									</div>
								</div>
								<div class="col-md-4 col-xs-4 part-price text-right">
									<p>${{ activeBuild.streamingBundle.price | priceFormat }}</p>
								</div>
							</div>
							<p v-if="checkDisabled(activeBuild.streamingBundle)" class="part-warning" @click="fixPart(activeBuild.streamingBundle)">
								<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
								No longer available. Remove.
							</p>
						</div>
						<div class="part-item part-item-peripheral" v-if="activeBuild.peripherals && activeBuild.peripherals.length && (activeBuild.peripherals[0].id || activeBuild.peripherals.length > 1)">
							<div class="row">
								<div class="col-xs-12">
									<div class="part-name pull-left">PERIPHERALS:</div>
									<div class="msrp pull-right">MSRP</div>
								</div>
							</div>
							<template v-for="(peripheral, index) in activeBuild.peripherals">
								<div class="row" :key="`overlay-peripheral-${index}`">
									<div class="col-md-8 col-xs-8 text-left">
										<div class="part-label">
											<p :class="{ unavailable: checkDisabled(peripheral) }" v-if="peripheral.id">
												{{ peripheral.title }} {{ peripheral.colors ? '(' + peripheral.colors + ')' : '' }}
											</p>
										</div>
									</div>
									<div class="col-md-4 col-xs-4 part-price text-right">
										<template v-if="peripheral.id">
											<p>${{ peripheral.price | priceFormat }}</p>
										</template>
									</div>
								</div>
								<p
									v-if="checkDisabled(peripheral)"
									:key="`overlay-peripheral-${index}-warn`"
									class="part-warning"
									@click="fixPart(peripheral)"
								>
									<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
									No longer available. Remove.
								</p>
							</template>
						</div>
						<div class="part-item part-item-8" v-if="activeBuild.monitors && activeBuild.monitors.length && (activeBuild.monitors[0].id || activeBuild.monitors.length > 1)">
							<div class="row">
								<div class="col-xs-12">
									<div class="part-name pull-left">MONITORS:</div>
									<div class="msrp pull-right">MSRP</div>
								</div>
							</div>
							<template v-for="(monitor,index) in activeBuild.monitors">
								<div class="row" :key="`overlay-monitor-${index}-${monitor.products_id}`">
									<div class="col-md-8 col-xs-8 text-left">
										<div class="part-label">
											<p :class="{ unavailable: checkDisabled(monitor) }" v-if="monitor.id">
												{{ monitor.title }}
												<template v-if="monitor.quantity > 1">
													({{ monitor.quantity }})
												</template>
											</p>
										</div>
									</div>
									<div class="col-md-4 col-xs-4 part-price text-right">
										<template v-if="monitor.id">
											<p>${{ monitor.price * monitor.quantity | priceFormat }}</p>
										</template>
									</div>
								</div>
								<p
									v-if="checkDisabled(monitor)"
									:key="`overlay-monitor-${index}-${monitor.products_id}-warn`"
									class="part-warning"
									@click="fixPart(monitor)"
								>
									<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
									No longer available. Remove.
								</p>
							</template>
						</div>
						<div class="part-item part-item-software">
							<div class="row" v-if="activeBuild.software">
								<div class="col-md-8 col-xs-8 text-left">
									<div class="part-name">SOFTWARE:</div>
									<div class="part-label">
										<p :class="{ unavailable: checkDisabled(activeBuild.software) }">
											{{ activeBuild.software.title }}
										</p>
									</div>
								</div>
								<div class="col-md-4 col-xs-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>${{ activeBuild.software.price | priceFormat }}</p>
								</div>
							</div>
							<p v-if="checkDisabled(activeBuild.software)" class="part-warning" @click="$emit('fix-this', 'software', 'software-options')">
								<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
								No longer available, choose another.
							</p>
						</div>
						<div class="part-item part-item-add">
							<div class="row" v-if="activeBuild.services">
								<div class="col-md-8 col-xs-8 text-left">
									<div class="part-name">SERVICE:</div>
								</div>
								<div class="col-md-4 col-xs-4 part-price text-right">
									<div class="msrp">${{ activeBuild.services.price | priceFormat }}</div>
								</div>
							</div>
							<covid-19>
								<template v-slot:current>
									<p v-if="checkDisabled(activeBuild.services)" class="part-warning" @click="$emit('fix-this', 'services', 'service-options')">
										<img src="/images/icons/step-5-icons/part-warning.svg" alt="">
										No longer available, choose another.
									</p>
									<div class="part-label">
										<p :class="{ unavailable: checkDisabled(activeBuild.services) }" class="shipping_service_description">
											BLD Assembly &amp; Service Package {{ activeBuild.services.title }}
										</p>
										<ul>
											<li v-if="serviceSlug == 'blitzmode'">Ships same or next business day</li>
										</ul>
										<div v-html="ordersShipping.shipping_expectation" />

										<div class="shipping_service_note" v-html="ordersShipping.miscellaneous" />

										<div class="shipping_service_note">
											Estimated shipping date {{ shippingDate }}
										</div>
									</div>
								</template>
								<template v-slot:covid>
									<div class="part-label">
										<p :class="{ unavailable: checkDisabled(activeBuild.services) }" class="shipping_service_description">
											BLD Assembly &amp; Service Package {{ activeBuild.services.title }}
										</p>
										<p class="covid-text">
											Due to COVID-19, our custom PC build service is currently unavailable. You can sign up to get notified when the service is back or check out NZXT prebuilds.
										</p>
									</div>
								</template>
							</covid-19>
						</div>
					</div>
					<div class="checkout-price-bottom">
						<checkout-price
							:build-case="buildCase"
							:build-price="buildPrice"
							@checkout="$emit('checkout', 'bottom')"
							@showContingencyModal="$emit('show-contingency-modal')"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- /.modals-overlays -->
</template>
<script>
import { mapActions, mapState } from "vuex";
import _isEmpty from "lodash/isEmpty";
import { computeRamCapacity } from "@u/store-helpers";
import { heapAnalytics } from "@u/mixins";
import Covid19 from "@c/covid-19";
import CheckoutPrice from "./checkout-price";
import PromoSalesTimed from "@/components/promo-sales-timed";
import { casePromo, promoDiscount } from "@u/helpers";


export default {
	name: "Step5Specs",
	components: {
		Covid19,
		CheckoutPrice,
		PromoSalesTimed
	},
	filters: {
		priceFormat(value) {
			value = value ? value : 0;
			value = parseFloat(value).toFixed(2);
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	},
	mixins: [
		heapAnalytics
	],
	props: {
		activeBuild: {
			type: Object,
			required: true
		},
		sessionData: {
			type: Object,
			required: true
		},
		buildPrice: {
			type: [Number, String],
			required: true
		}
	},
	data() {
		return {
			disabledProducts: {},
			shippingDate: "",
			shouldShowBar: true
		};
	},
	computed: {
		...mapState({
			draftId: state => state.Step4.draftId,
			ordersShipping: state => state.Application.ordersShipping
		}),
		casesColorsList() {
			if (this.sessionData && this.sessionData.colors) {
				const groupedCaseColors = _.groupBy(this.sessionData.colors.case, "products_id");
				return groupedCaseColors[this.activeBuild.case.products_id] || [];
			}
			return [];
		},
		motherboardColorsList() {
			if (this.sessionData && this.sessionData.colors) {
				const groupedMotherboardColors = _.groupBy(this.sessionData.colors.motherboards, "products_id");
				return groupedMotherboardColors[this.activeBuild.motherboard.products_id] || [];
			}
			return [];
		},
		serviceSlug() {
			return this.activeBuild.services.name.toLowerCase().replace(/[^a-z]/g, "");
		},
		totalStorage() {
			return (this.activeBuild.ssd[0].id && this.activeBuild.ssd.length || 0) +
                (this.activeBuild.hdd[0].id && this.activeBuild.hdd.length || 0);
		},
		buildCase() {
			if (!_isEmpty(this.activeBuild)) {
				return this.activeBuild.case;
			}

			return {};
		},
		discountPrice() {
			return promoDiscount(this.activeBuild.case.price);
		},
		applyCase() {
			return casePromo(this.buildCase);
		}
	},
	created() {
		this.getShippingDate();
	},
	methods: {
		...mapActions([
			"changeShowLoadingOverlay",
			"setActiveBuild",
			"setBuildPrice"
		]),
		computeRamCapacity,
		addPart(part, updateStore = true) {
			this.changeShowLoadingOverlay(true);

			return axios({
				url: `/update-part/${part.id}/0/1?pid=${part.products_id}&validate=true`,
				method: "GET",
				headers: {
					token: window.CONFIG.SESSION
				}
			}).then((response) => {
				updateStore && this.updateStore(response.data);
			});
		},
		checkDisabled(product) {
			const isDisabled = Boolean((Number(product.disabled_product) || Number(product.disabled_variant)) && !Number(product.is_limited)) ||
                Boolean(Number(product.disabled_variant) && Number(product.is_limited));

			if (isDisabled) {
				let productTitle = product.title;

				if (product.colors) {
					productTitle += ` (${product.colors})`;
				}

				this.disabledProducts[product.product_modules_slug] = productTitle;
			}

			return isDisabled;
		},
		getDisabledProducts() {
			return this.disabledProducts;
		},
		fixCase() {
			let tab = "case";
			let subtab = "case-options";

			if (Number(this.activeBuild.case.is_limited) && Number(this.activeBuild.case.disabled_variant)) {
				subtab = "limited-cases";
			} else {
				if (!Number(this.activeBuild.case.disabled_product) && Number(this.activeBuild.case.disabled_variant)) {
					tab = "color";
					subtab = "color-options";
				}
			}

			this.$emit("fix-this", tab, subtab);
		},
		fixFan(fan) {
			let tab = "cooling";
			let subtab = "cooling-fans";

			if (!Number(fan.cam_lighting)) {
				if (!Number(fan.disabled_product) && Number(fan.disabled_variant)) {
					tab = "color";
					subtab = "color-options";

					this.$emit("fix-this", tab, subtab);
				} else {
					this.removePart(fan);
				}
			} else {
				this.removePart(fan);
			}
		},
		fixMotherboard() {
			let tab = "motherboard";
			let subtab = "motherboard-options";

			if (!Number(this.activeBuild.motherboard.disabled_product)) {
				const colors = this.sessionData.colors.motherboards.filter(motherboard => {
					return motherboard.products_id == this.activeBuild.motherboard.products_id;
				});

				if (colors.length) {
					tab = "color";
					subtab = "color-options";
				}
			}

			this.$emit("fix-this", tab, subtab);
		},
		fixPart(part) {
			this.removePart(part);
		},
		async fixStorage(disk) {
			if (this.totalStorage == 1) {
				// Because of how things are, this has to be done. Not something nice for sure. But it works.
				// @TODO Remove this once the real fix on backend is ready.
				await this.addPart(this.sessionData.hdd[0], false);
				await this.removePart(disk, false);
				await this.addPart(this.sessionData.ssd[0].options[0], false);
				await this.removePart(this.sessionData.hdd[0]);

				this.$emit("fix-this", "storage", "ssd-options");
			} else {
				this.removePart(disk);
			}
		},
		getShippingDate() {
			axios({
				url: `/shipping-date/${this.activeBuild.services.id}`,
				headers: {
					token: window.CONFIG.SESSION
				}
			}).then((response) => {
				this.shippingDate = response.data.date;
			}).catch((error) => {
				// eslint-disable-next-line no-console
				console.log(error);
			});
		},
		getDeviceType() {
			const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
			return regex.test(navigator.userAgent) ? "mobile" : "desktop";
		},
		removePart(part, updateStore = true) {
			this.changeShowLoadingOverlay(true);

			return axios({
				url: `/delete-part/${part.id}?pid=${part.products_id}`,
				headers: {
					token: window.CONFIG.SESSION
				}
			}).then((response) => {
				this.$delete(this.disabledProducts, part.product_modules_slug);
				updateStore && this.updateStore(response.data);
			});
		},
		showErrorModal(message) {
			this.$modal.show("general", {
				title: "Error",
				content: message
			});
		},
		updateBuildInDatabase() {
			return axios({
				url: `/users/0/letsbld-drafts/${this.draftId}?session=${window.CONFIG.SESSION}`,
				method: "PUT"
			});
		},
		updateStore(data) {
			this.setBuildPrice(data.total);
			this.setActiveBuild(data.build);
			this.changeShowLoadingOverlay(false);
			this.updateBuildInDatabase();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.holiday-promo {
	display: flex;
	justify-content: flex-end;

	.holiday-discount {
		text-decoration: line-through;
		margin-left: 5px;
	}
}

.highlight {
    color: $orchid;
}

.step-5-specs {
    color: #CFCFCF;

    @media (max-width: 768px) {
        margin-top: 25px;
    }

    > .container-fluid {
        padding: 0;

        > .row {
            @media (min-width: 991px) {
                display: flex;

                div.col-md-6.col-xs-12:last-child {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }
            }
        }

        @media (max-width: 768px) {
            .row {
                .col-xs-8, .col-xs-4 {
                    padding: 0;
                }
            }
        }
    }

    .part-item {
        margin-bottom: 25px;

        .col-xs-12 {
            @media (max-width: 768px) {
                padding: 0;
            }
        }
    }

    .part-item-add {
        @media (max-width: 768px) {
            margin: 0 -15px;

            > .row {
                padding: 0 15px;
            }
        }
    }

    .part-name, .msrp {
        font-size: 16px;
    }

    .part-label, .part-price p {
        font-family: 'akkurat-light';
        font-size: 18px;

        @media (max-width: 768px) {
            font-size: 16px;
        }
    }

    .part-label p, .part-price p {
        margin-bottom: 0;
    }

    .part-label::v-deep {
        .unavailable {
            text-decoration: line-through;
        }

		> ul {
			margin-bottom: 0;
            padding-top: 30px;
		}

        ul {
            padding-left: 20px;

            li {
                line-height: 24px;

                .pink-text {
                    color: $orchid;
                }
            }
        }
    }

    .part-warning {
        color: $orchid;
        cursor: pointer;
        display: flex;
        font-size: 18px;
        font-family: 'akkurat-light';

        @media (max-width: 768px) {
            display: block;
            margin-left: -15px;
        }

        img {
            margin-right: 5px;
        }
    }

    .shipping_service_note {
        margin-top: 25px;

        &__title {
            margin-top: 5px;
            font-size: 16px;
        }
    }

    .checkout-price-bottom {
        @media (max-width: 767px) {
            z-index: 2;
            display: flex;
            justify-content: center;
            background-color: #111111;
            margin: 0 -30px;
            position: fixed;
            bottom: 0;
            width: 100%;
            right: 8%;
        }

        @media (min-width: 991px) {
            position: relative;
            top: 17px;
        }
    }
}

#overlay-checkout-btn {
    background-color: $orchid;
    border-color: $orchid;
}

.covid-text {
    margin-top: 30px;
    color: #BF4CBF;
    font-family: Akkurat-Light;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 25px
}

.shipping {
    color: #BF4CBF;
    font-family: Akkurat-Light;
		font-weight: 600;
    font-size: 16px;
		margin-bottom: 5px !important;
}

</style>
